import { createSelector } from '@ngrx/store';

import {
  selectLayouts,
  selectLayout,
  selectLandmarks,
  selectSections,
  selectValidInventoryUnitIds,
  selectSelectedLayoutUnitPositions,
  selectLayoutsLoading,
  selectLayoutError,
} from '../core/reducers/layout.reducer';

export const getLayouts = selectLayouts;
export const getLayout = selectLayout;
export const getLayoutLandmarks = createSelector(
  selectLandmarks,
  landmarks => (id: number) => landmarks.filter(l => l.layout_id === id),
);
export const getLayoutSections = createSelector(
  selectSections,
  sections => (id: number) => sections.filter(s => s.layout_id === id),
);
export const getLayoutValidPositions = selectValidInventoryUnitIds;
export const getLayoutSelectedUnitPositions = selectSelectedLayoutUnitPositions;
export const getLayoutsLoading = selectLayoutsLoading;
export const getLayoutError = selectLayoutError;
